module.exports = __webpack_public_path__ + "static/img/52-2.ed20396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/52-2.jpg
// module id = lnKy
// module chunks = 0